import { sort } from "fast-sort";
import { Icon } from "icons";
import { useTranslation } from "react-i18next";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandList,
} from "ui";

import { type WorkoutItemAttributePickerContentProps } from "./WorkoutItemAttributePicker";
import { WorkoutItemAttributePickerItem } from "./WorkoutItemAttributePickerItem";

export function WorkoutItemAttributePickerContent(
  props: WorkoutItemAttributePickerContentProps,
) {
  const translation = useTranslation();

  function getLabel(name: string) {
    return translation.t(`workoutItemSets.attributes.${name}`, {
      defaultValue: name,
    });
  }

  if (props.isAttributesPending) {
    return (
      <div className="flex items-center justify-center p-4">
        <Icon name="tabler-loader-2" className="size-4 animate-spin" />
        <span className="sr-only">
          {translation.t("workoutItemSets.loadingAttributes", {
            defaultValue: "Loading attributes",
          })}
        </span>
      </div>
    );
  }

  const attributes = sort(props.attributes ?? []).asc((attribute) => {
    return getLabel(attribute.name);
  });

  return (
    <Command>
      <CommandInput
        placeholder={translation.t(
          "workoutItemSets.attributeSearchPlaceholder",
          { defaultValue: "Search attributes..." },
        )}
      />
      <CommandEmpty>
        {translation.t("workoutItemSets.noAttributes", {
          defaultValue: "No attributes found",
        })}
      </CommandEmpty>
      <CommandList>
        <CommandGroup>
          {attributes.map((attribute) => {
            return (
              <WorkoutItemAttributePickerItem
                key={attribute.id}
                attribute={attribute}
                label={getLabel(attribute.name)}
                {...props}
              />
            );
          })}
        </CommandGroup>
      </CommandList>
    </Command>
  );
}
